// extracted by mini-css-extract-plugin
module.exports = {"menu-list-container":"styles_menu-list-container__6eV7Y"};